// extracted by mini-css-extract-plugin
export default {"container":"Gnk0gZ","iconWrapper":"uHHygg"};